import { connect } from 'react-redux'
import SubcontractorCellModal from './SubcontractorCellModal'

import componentDidMount from './Handlers/componentDidMount'
import componentWillUnmount from './Handlers/componentWillUnmount'
import onChangeActiveTab from './Handlers/onChangeActiveTab'
import onAddJob from './Handlers/onAddJob'
import onUpdateJob from './Handlers/onUpdateJob'
import onRemoveJob from './Handlers/onRemoveJob'
import onUpdatePlannerCell from './Handlers/onUpdatePlannerCell'
import onChangeDuplicateKey from './Handlers/onChangeDuplicateKey'
import onSave from './Handlers/onSave'

const mapStateToProps = (state) => ({
  projects: state.core.projects,
  activeTab: state.screens.Planner.SubcontractorCellModal.activeTab,
  jobs: state.screens.Planner.SubcontractorCellModal.jobs,
  plannerCell: state.screens.Planner.SubcontractorCellModal.plannerCell,
  duplicate: state.screens.Planner.SubcontractorCellModal.duplicate,
})

const actionCreators = {
  componentDidMount,
  componentWillUnmount,
  onChangeActiveTab,
  onAddJob,
  onUpdateJob,
  onRemoveJob,
  onUpdatePlannerCell,
  onChangeDuplicateKey,
  onSave,
}

export default connect(mapStateToProps, actionCreators)(SubcontractorCellModal)
